// import tinycolor from 'tinycolor2';
import formatMoney from '../../core/formatMoney';
import { handleize } from '../../core/helpers';

// const STATIC_FILTERS = Object.freeze(['product type', 'size', 'color', 'price']);
/*const NOSTO_FILTERS = Object.freeze({
  COLOR: 'skus.customFields.astr-color_family',
  SIZE: 'skus.customFields.size',
  TYPE: 'customFields.producttype',
  PRICE: 'price',
  TAGS: 'tags1',
});*/

/*
// filter name = vuetag type from vt::dresses::sleeve length::*
const VT_FILTERS = Object.freeze({
  // 'style': 'style & occasion',
  'neckline': 'neckline',
  //'pattern': 'pattern',
  'style': 'style',
  'occasion': 'occasion',
  'dress length': 'dress length',
  'sleeve length': 'sleeve length',
});

// Vue Tag Categories associated to their main collection
// vt::Sweaters::Neckline::Collared
const VT_CATEGORIES = Object.freeze({
  'Blazer': 'blazers',
  'Bottoms': 'bottoms',
  'Cardigans': 'cardigans',
  'Coats': 'coats',
  'Dresses': 'dresses',
  'Jackets': 'jackets',
  'Jumpsuits': 'jumpsuits-rompers',
  // 'Other': '',
  'Outerwear': 'jackets-outerwear',
  'Pants': 'pants',
  // 'Rompers': '',
  'Shorts': 'shorts',
  'Skirts': 'skirts',
  'Sweaters': 'sweaters',
  'Tops': 'tops',
  'Vests': 'vests',
  'All': 'shop-all',
  'All Wedding': 'wedding-shop-all',
});
*/

// Now defined with metaobjects - JSON created from theme.liquid
const STATIC_FILTERS = Object.freeze(JSON.parse(document.querySelector('[data-filter-static-json]').innerHTML));
const VT_FILTERS = Object.freeze(JSON.parse(document.querySelector('[data-filter-categories-json]').innerHTML));
const VT_CATEGORIES = Object.freeze(JSON.parse(document.querySelector('[data-filter-collections-json]').innerHTML));

// Example: vt::Dresses::Neckline::Cowl => Dresses is tag_category
const hasCategory = (tag_category) => {
  const collectionGridEl = document.querySelector('[data-collection-grid]');
  if (!collectionGridEl) {
    return false;
  }

  let collection_handle = collectionGridEl.dataset.collection ?? '';

  // Remove the last part for color collections
  const collection_handle_array = collection_handle.split('-');
  collection_handle_array.pop();
  collection_handle = (collectionGridEl.dataset.colorCollection === 'true') ? collection_handle_array.join('-') : collection_handle;

  let has_category = Object.entries(VT_CATEGORIES).find(([key, val]) => key === tag_category && val === collection_handle) === undefined ? false : true;

  // Check if the collection metafield astr.parent_collection has a value that matches the collection_handle
  if (!has_category) {
    const parent_collection_handle = collectionGridEl.dataset.parentCollection ?? '';

    if (parent_collection_handle) {
      has_category = Object.entries(VT_CATEGORIES).find(([key, val]) => key === tag_category && val === parent_collection_handle) === undefined ? false : true;
    }
  }

  return has_category;
};

const filterOptionTemplate = (data, index) => {
  const { options, handleized_colors, color_families, color_check, handleized_options, cleanup_prices, from_search } = data;
  let option_label = options[index][0];
  if (cleanup_prices.length) { option_label = cleanup_prices[index]; }

  // return '';
  return `
    <li data-clickable-option-li role="option" aria-selected="false">
      <div class="newfilter-checkbox${(color_families.length) ? ` has-hex ${color_check[index]}` : ''}${(handleized_colors.length) ? ` has-swatch` : ''}"
        data-clickable-option
        data-option-short-value="${handleized_options[index]}"
        data-option-value="${options[index][0]}"
        data-available="${(typeof options[index][1] === 'undefined') ? '' : options[index][1]}"
        tabindex="0"
        aria-label="${options[index][0]} option">
          <div class="newfilter-checkbox__field"${(color_families.length) ? ` style="background-color: ${color_families[index]} !important;"` : ''}${(handleized_colors.length) ? ` data-color-handle="${handleized_colors[index]}"` : ''}>${(handleized_colors.length) ? `<span></span>` : ''}
            <input type="checkbox" name="ada_option[]" class="visually-hidden" value="${options[index][0]}" aria-label="${options[index][0]} filter option" data-option-ada />
          </div>

          <span class="newfilter-checkbox__label" tabindex="-1">${option_label}</span>

          <div class="newfilter-checkbox__check" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" aria-label="Filter checkbox decoration" width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M1 6L4.5 9L11 1" stroke="black" stroke-width="0.7"/></svg>
          </div>
        </div>
    </li>`;
};

const filterCategoryTemplate = (data) => {
  const { prefix, category_handle, category_name } = data;

  return `
    <li
      class="${prefix}filter-filtering__option filter-option"
      data-${prefix}filter-options
      data-${prefix}filter-options-type="${category_handle}">
      <div class="filter-option__header" role="tablist" aria-label="${category_name} filters">
        <button 
          class="filter-option__button"
          id="tab-${category_handle}"
          data-${prefix}filter-button
          role="tab"
          aria-selected="false"
          aria-controls="panel-${category_handle}"
          aria-label="${category_name} filter">
          <span>${category_name}</span>
        </button>
      </div>

      <div id="filterType_${category_handle}"
           class="filter-option__container"
           data-${prefix}filter-options-container
           role="tabpanel"
           aria-labelledby="tab-${category_handle}"
           tabindex="0">
        <ul
          class="filter-option__items"
          data-${prefix}filter-options-items
          role="listbox"
          aria-live="polite"
          aria-multiselectable="true"
          aria-label="${category_name} option">
        </ul>
      </div>
    </li>
  `;
};

const orderByVTFilters = (tagFilters) => {
  return Object.entries(VT_FILTERS).reduce((acc, [_, filterValue]) => {
    const matchingKey = Object.keys(tagFilters).find(k =>
      k.toLowerCase().includes(filterValue));
    if (matchingKey) {
      acc[matchingKey] = tagFilters[matchingKey];
    }
    return acc;
  }, {});
};

const buildTagFilters = (facets) => {
  let tag_filters = {};
  const filter_tags_options = facets.find((facet) => facet.name.toLowerCase() === 'tags');


  if (typeof filter_tags_options !== 'undefined') {
    filter_tags_options.data.filter((option) => {
      if (option.value.includes('vt::')) {
        const vt_parts = option.value.split('::');
        const vt_filter_name = `vt::${vt_parts[1]}::${vt_parts[2]}`;

        // Only use the tags from the VT_FILTERS
        const has_filter = Object.values(VT_FILTERS).includes(vt_parts[2].toLowerCase());
        // Only use the tags from the VT_CATEGORIES
        // const has_category = Object.entries(VT_CATEGORIES).find(([key, val]) => key === vt_parts[1] && val === collection_handle) === undefined ? false : true;
        const has_category = hasCategory(vt_parts[1]);

        if (has_filter && has_category) {
          if (typeof tag_filters[vt_filter_name] === 'undefined') {
            tag_filters[vt_filter_name] = {};
          }

          if (typeof tag_filters[vt_filter_name][vt_parts[3]] === 'undefined') {
            tag_filters[vt_filter_name][vt_parts[3]] = option.count;
          }
        }
      }
    });

    // console.log('tag_filters', tag_filters);

    tag_filters = orderByVTFilters(tag_filters);

    // Follow the Nosto format
    Object.keys(tag_filters).forEach((tag_filter) => {
      facets.push({
        id: handleize(tag_filter),
        field: tag_filter,
        type: 'custom',
        name: tag_filter,
        data: Object.keys(tag_filters[tag_filter]).map((custom_filter) => {
          return { value: custom_filter, count: tag_filters[tag_filter][custom_filter] };
        }),
      });
    });
  }

  return facets;
};

export default () => {
  try {
    let show_tag_filters = false;
    const from_search = document.body.classList.contains('has-overlay-search');
    const prefix = from_search ? 'overlay-search-' : '';
    let facets = (from_search) ? window.theme.search.facets : window.theme.collections.facets;
    const show_color_families_filter = (from_search || (document.querySelector('[data-collection-grid]') && document.querySelector('[data-collection-grid]').dataset.colorCollection !== 'true')) ? true : false;
    // console.log('[ASTR] facets', wfacets);

    // Only show the product type filter on shop all
    // if (window.location.pathname.includes('/collections/shop-all')) {
    //   STATIC_FILTERS.unshift('product_type');
    // }

    // Don't show the tag filters on search overlay
    if (!from_search) {
      show_tag_filters = true;
    }

    if (from_search) {
      // Filters are getting rebuilt when search is done
      const filter_items = document.querySelector('.overlay-search-filter-option__items');
      const mobile_filter_nav = document.querySelector('[data-mobile-overlay-search-filter-nav-options]');

      if (filter_items) {
        filter_items.innerHTML = '';
      }

      if (mobile_filter_nav) {
        mobile_filter_nav.innerHTML = '';
      }
    }

    // Add the VueTag tags to the facets as separate property
    if (show_tag_filters) {
      facets = buildTagFilters(facets);
    }
    // console.log('facets 2', facets);

    for (let i = 0; i < facets.length; i++) {
      const facet = facets[i];
      const filter_options = facet.data;
      const filter_name = facet.name.toLowerCase();
      const handleized_options = [];
      // Keep the option in an array instead of the Algolia object for compatibility with older code
      const options = [];

      // Handleized colors
      const handleized_colors = [];
      const color_families = [];
      const color_check = [];

      if (filter_name === 'color' && show_color_families_filter) {
        filter_options.forEach((option) => {
          // Find the matching color family within our Json file (will be better to save the satch values in metafields in the future)
          window.theme.collections.color_families_swatches.find((color_family) => {
            if (color_family.color_handle === option.value) {
              color_families.push(color_family.swatch_value);

              // const filter_color = tinycolor(color_family.family.swatch_value);
              // const check_class = (filter_color.isDark()) ? 'light-check' : 'dark-check';
              const check_class = 'dark-check';
              color_check.push(check_class);
            }
          });

          options.push([option.value, option.count]);
          handleized_options.push(handleize(option.value));
        });
      }

      if (filter_name === 'size') {
        const sort_options = [['XXS', 0], ['XS', 0], ['S', 0], ['SM', 0], ['M', 0], ['ML', 0], ['L', 0], ['XL', 0], ['XXL', 0], ['1X', 0], ['2X', 0], ['3X', 0], ['4X', 0], ['5X', 0], ['6X', 0], ['7X', 0], ['8X', 0], ['9X', 0], ['OS', 0]];

        sort_options.forEach((sort_option) => {
          filter_options.forEach((option) => {
            if (option.value === sort_option[0]) {
              sort_option[1] = option.count;
              handleized_options.push(handleize(sort_option[0]));
            }
          });
        });

        sort_options.forEach((sort_option) => {
          if (sort_option[1] !== 0) {
            options.push(sort_option);
          }
        });
      }

      // We don't receive the price ranges from Nosto, just the min and max prices; dynamically build them
      const cleanup_prices = [];
      if (filter_name === 'price') {
        const min_price = facet.min || 0;
        const max_price = facet.max || 10000;

        const prices = [25, 50, 75, 100, 150, 200, 250, 300, 400, 500, 750, 1000, 1500, 2000, 2500, 3000, 4000, 5000];
        for (let i = 0; i < prices.length; i++) {
          const price = prices[i];
          const next_price = prices[i + 1] || 10000;

          if (price < min_price) {
            continue;
          }

          cleanup_prices.push(`${formatMoney(Math.ceil(Number(price) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}-${formatMoney(Math.ceil(Number(next_price) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}`);
          // We don't receive a count from Nosto for price ranges
          const option_value = `${price}-${next_price}`;
          options.push([`${option_value}`]);
          handleized_options.push(handleize(`${option_value}`));

          if (next_price >= max_price) {
            break;
          }
        }
      }

      if (filter_name === 'product type') {
        filter_options.forEach((option) => {
          options.push([option.value, option.count]);
          handleized_options.push(handleize(option.value));
        });
      }

      // Color family filter
      // const color_families = [];
      // const color_check = [];
      // if (filter[0].includes('Isp-color-family') && show_color_families_filter) {
      //   _.each(filter[1], (option) => {
      //     // Example: option = ["Brown", 24, "#8b4513"]
      //     color_families.push(option[2]);

      //     const filter_color = tinycolor(option[2]);
      //     const check_class = (filter_color.isDark()) ? 'light-check' : 'dark-check';
      //     color_check.push(check_class);

      //     // For consistency, only needed for tag_filter_ elements
      //     handleized_options.push(handleize(option[0]));
      //   });
      // }

      // Cleanup tag options
      if (show_tag_filters && filter_name.includes('vt::')) {
        filter_options.forEach((option) => {
          options.push([option.value, option.count]);

          // Some options have a leading space :(
          // handleized_options.push(option.value.trim());
        });
      }

      if (STATIC_FILTERS.includes(filter_name) || (filter_name.includes('vt::') && show_tag_filters)) {
        // console.log('==================================================================');
        // console.log('build filter for ', filter_name);
        // console.log('filter_options', filter_options);
        // console.log('color_families', color_families);
        // console.log('color_check', color_check);
        // console.log('handleized_options', handleized_options);
        // console.log('cleanup_prices', cleanup_prices);

        const category_handle = facet.field;
        let category_name = filter_name;
        // if (filter_name === 'price_range') { category_name = 'price'; }
        // if (filter_name === 'product type') { category_name = 'type'; }

        // We need to keep this format for the category_handle for Nosto vt::Dresses::Dress Length
        if (filter_name.includes('vt::')) {
          category_name = filter_name.replace('vt::', '');
          const category_name_parts = category_name.split('::');
          category_name = category_name_parts[1].trim();
          /*
          // category_handle = `vt--${category_name_parts[0]}--${category_name_parts[1]}`;
          // category_handle = filter_name;
          category_handle = `vt::${handleize(category_name_parts[1])}`;
          */
        }

        // Build the container for each filter
        // It's possible the option already exists vt::Sweaters::Sleeve Length & vt::Tops::Sleeve Length share the same option for instance
        // Delete the container, it can get created and options not appended when typing quickly "blue dress" for instance
        document.querySelectorAll(`[data-${prefix}filter-by] [data-${prefix}filter-options-type="${category_handle}"]`).forEach(el => el.remove());
        // if ($(`[data-${prefix}filter-by] [data-${prefix}filter-options-type="${category_handle}"]`).length === 0) {
        // const compiled_category = _.template(filterCategoryTemplate(), {imports: { jq: $ } });
        // const category_html = compiled_category({ category_handle, category_name, prefix });
        const category_html = filterCategoryTemplate({ category_handle, category_name, prefix });

        // Append to desktop filter container
        const filterByEl = document.querySelector(`[data-${prefix}filter-by]`);
        if (filterByEl) {
          filterByEl.insertAdjacentHTML('beforeend', category_html);
        }

        // Append to mobile filter container if present
        const mobileFilterNavEl = document.querySelector(`[data-mobile-${prefix}filter-nav-options]`);
        if (mobileFilterNavEl) {
          mobileFilterNavEl.insertAdjacentHTML('beforeend', category_html);
          // $(category_html).insertBefore(`[data-mobile-${prefix}filter-sorting]`);
        }
        // }

        // Add the options to the filter
        if ($(`[data-${prefix}filter-options-type="${category_handle}"]`).length && options.length) {
          // const compiled_options = _.template(`
          //   <% jq.each(options, function(index) { %>${filterOptionTemplate()}<% }); %>
          // `, {imports: { jq: $ } });

          // const options_html = compiled_options({ options, handleized_colors, color_families, color_check, handleized_options, cleanup_prices, from_search });

          let options_html = '';
          options.forEach((option, index) => {
            options_html += filterOptionTemplate({ options, handleized_colors, color_families, color_check, handleized_options, cleanup_prices, from_search }, index);
          });

          $(`[data-${prefix}filter-options-type="${category_handle}"] [data-${prefix}filter-options-items]`).html(options_html);

          const optionsContainer = document.querySelectorAll(`[data-${prefix}filter-options-type="${category_handle}"] [data-${prefix}filter-options-items]`);
          if (optionsContainer) {
            optionsContainer.forEach(container => {
              container.innerHTML = options_html;
            });
          }
        }

        // Hide duplicate options on certain collections mixing product types (For instance, V Neck can be for vt::Tops::Neckline::V Neck, vt::Sweaters::Neckline::V Neck, vt::Dresses::Neckline::V Neck...)
        // /collections/fall-collection-21

        // Convert array to unique values using Set
        [...new Set(handleized_options)].forEach(option => {
          const desktop_options = document.querySelectorAll(`[data-${prefix}filter-by] [data-${prefix}filter-options-type="${category_handle}"] [data-option-short-value="${option}"]`);
          const mobile_options = document.querySelectorAll(`[data-mobile-${prefix}filter-nav-options] [data-${prefix}filter-options-type="${category_handle}"] [data-option-short-value="${option}"]`);

          // Hide duplicates if more than one option exists
          if (desktop_options.length > 1) {
            desktop_options.forEach(opt => opt.parentElement.classList.add('hide'));
            desktop_options[0].parentElement.classList.remove('hide');
            desktop_options[0].setAttribute('data-master-option', 'true');

            mobile_options.forEach(opt => opt.parentElement.classList.add('hide'));
            mobile_options[0].parentElement.classList.remove('hide');
            mobile_options[0].setAttribute('data-master-option', 'true');
          }
        });
      }
    };

    // Hide all filters without data or with only 1 item in it  
    document.querySelectorAll(`[data-${prefix}filter-options]`).forEach(item => {
      const filterItems = item.querySelector(`[data-${prefix}filter-options-items]`);
      if (filterItems && filterItems.querySelectorAll('li').length <= 1) {
        item.remove();
      }
    });
  } catch (error) {
    console.log(error);
  }
};
